import React from "react";
import PropTypes from "prop-types";
import images from "../../../images";

const Counter = ({ value, onChange }) => {
  const handleDecrease = () => {
    if (value > 1) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    onChange(value + 1);
  };

  return (
    <div className="flex overflow-hidden gap-10 justify-between items-center px-2.5 py-2.5 w-full bg-white rounded-xl border border-solid border-stone-200 min-h-[42px]">
      <img
        onClick={handleDecrease}
        src={images.MinusIcon}
        className="object-contain w-6 h-6 cursor-pointer"
        alt="Decrease"
      />
      <span className="self-stretch my-auto text-sm font-medium text-zinc-800">
        {value}
      </span>
      <img
        onClick={handleIncrease}
        src={images.SumIcon}
        className="object-contain self-stretch my-auto aspect-square w-6 h-6 cursor-pointer"
        alt="Increase"
      />
    </div>
  );
};

Counter.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Counter;
